import React from 'react';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';
import { EntityGraphNode } from '../RelationsGraphCard/EntityGraphNode';

/**
 * The catalog graph card of the catalog-graph plugin, with nodes that are
 * links - so that an entity in the graph opens in a new tab like any other
 * link does, see EntityGraphNode.
 */
export const RTLCatalogGraphCard = (
  props: React.ComponentProps<typeof EntityCatalogGraphCard>,
) => <EntityCatalogGraphCard renderNode={EntityGraphNode} {...props} />;
